import * as React from 'react';
import * as style from './Navigation.css';
import { TPage } from '../../types/helper';
import { STEPS } from '../../constants/page-content';
import { mergeStyles } from '@cian/utils';

export interface INavigationStateProps {
  page: TPage;
}

export interface INavigationDispatchProps {
  redirectPage(page: TPage): void;
}

export interface INavigationComponentProps {
  collapsible?: boolean;
}

export type TNavigationProps = INavigationStateProps & INavigationDispatchProps & INavigationComponentProps;

interface INavigationState {
  isCollapsed: boolean;
}

export class Navigation extends React.Component<TNavigationProps, INavigationState> {
  public static defaultProps = {
    collapsible: false,
  };

  public state = {
    isCollapsed: false,
  };

  public handleHeaderClick = (e: React.SyntheticEvent) => {
    if (this.props.collapsible) {
      this.setState({ isCollapsed: !this.state.isCollapsed });
    }
    e.preventDefault();
  }

  public handleNavigationClick = (page: TPage) => (e: React.SyntheticEvent) => {
    const { collapsible, redirectPage, page: currentPage } = this.props;
    if (page !== currentPage) {
      redirectPage(page);
      if (collapsible) {
        this.setState({ isCollapsed: false });
      }
    }
    e.preventDefault();
  }

  public render() {
    const { collapsible, page: currentPage } = this.props;
    const { isCollapsed } = this.state;

    return (
      <div
        {...mergeStyles([
          style['container'],
          collapsible && style['container--collapsible'],
        ])}
      >
        <div className={style['header-wrap']}>
          <div className={style['header']} onClick={this.handleHeaderClick}>Другие разделы</div>
        </div>
        <div
            {...mergeStyles([
              style['list-wrap'],
              !collapsible || isCollapsed && style['list-wrap--collapsed'],
            ])}
        >
          <ul className={style['list']}>
            {STEPS.map(({ page, title }) => (
              <li
                key={page}
                {...mergeStyles([
                  style['list-item'],
                  currentPage === page && style['list-item--active'],
                ])}
              >
                <span onClick={this.handleNavigationClick(page as TPage)}>
                  {title}
                </span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    );
  }
}
